
import React, { useEffect, useState } from 'react'
import '../styleCss/a.css'
import SEO from '../SEO'
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import TypingText from './TypingText';

const Header = () => {


    useEffect(() => {
        window.scrollTo(0, 0); // scrolls to top when component mounts
    }, []);

    useEffect(() => {
        const navbar = document.getElementById("navbar");

        const media = window.matchMedia("(width <= 1024px)");

        function updateNavbar(e) {
            const isMobile = e.matches;
            const menu_div = document.getElementById("mob_menu");
            if (isMobile) {
                menu_div.style.display = "block";
                navbar.setAttribute("inert", "");
            } else {
                menu_div.style.display = "none";
                navbar.removeAttribute("inert");
            }
        }

        media.addEventListener("change", updateNavbar);
        updateNavbar(media);

        return () => media.removeEventListener("change", updateNavbar);
    }, []);




    const openSidebar = () => {
        const openButton = document.getElementById("open-sidebar-button");
        const navbar = document.getElementById("navbar");


        navbar.classList.add("show");
        openButton.setAttribute("aria-expanded", "true");
        openButton.style.display = "none";
        navbar.removeAttribute("inert");
    };

    const closeSidebar = () => {
        const openButton = document.getElementById("open-sidebar-button");
        const navbar = document.getElementById("navbar");

        if (openButton.getAttribute('aria-expanded') === 'true') {


            navbar.classList.remove('show');
            openButton.setAttribute('aria-expanded', 'false');
            openButton.setAttribute('style', 'display: block;');
            navbar.setAttribute('inert', '');

        }
    };




    return (
        <div >
            <SEO
                title="Algo Controller Trading | Algo Controller"
              

                description="Get real-time stock trading signals, live market updates, and PnL insights to make smarter trading decisions."
                url="https://www.algocontroller.com/"
                image="https://www.algocontroller.com/og-home.png"
            />

            <div id="mob_menu">
                <div className="row">
                    <div className="col-10" style={{ padding: "1.5rem 2rm" }}>
                        <a id="ftt"></a>
                    </div>
                    <div className="col-2">
                        <button id="open-sidebar-button" style={{ marginLeft: "-20px" }} onClick={openSidebar} aria-label="open sidebar" aria-expanded="false" aria-controls="navbar">
                            <svg xmlns="http://www.w3.org/2000/svg" height="5vh" viewBox="0 -960 960 960" width="5vh" fill="#050505"><path d="M165.13-254.62q-10.68 0-17.9-7.26-7.23-7.26-7.23-18t7.23-17.86q7.22-7.13 17.9-7.13h629.74q10.68 0 17.9 7.26 7.23 7.26 7.23 18t-7.23 17.87q-7.22 7.12-17.9 7.12H165.13Zm0-200.25q-10.68 0-17.9-7.27-7.23-7.26-7.23-17.99 0-10.74 7.23-17.87 7.22-7.13 17.9-7.13h629.74q10.68 0 17.9 7.27 7.23 7.26 7.23 17.99 0 10.74-7.23 17.87-7.22 7.13-17.9 7.13H165.13Zm0-200.26q-10.68 0-17.9-7.26-7.23-7.26-7.23-18t7.23-17.87q7.22-7.12 17.9-7.12h629.74q10.68 0 17.9 7.26 7.23 7.26 7.23 18t-7.23 17.86q-7.22 7.13-17.9 7.13H165.13Z" /></svg>
                        </button>
                    </div>
                </div>

            </div>
            {/* <div className="min-h-screen  "> */}

            <nav id="navbar">
                <ul>
                    <li>
                        <br /><br /><br />
                        <TypingText></TypingText>
                        <button id="close-sidebar-button" onClick={closeSidebar} aria-label="close sidebar">
                            <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="4" y1="4" x2="20" y2="20" stroke="black" strokeWidth="2" strokeLinecap="round" />
                                <line x1="20" y1="4" x2="4" y2="20" stroke="black" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </button>
                    </li>
                    <li className="home-li"><a className="active-link" aria-current="page" id="ft"></a></li>
                    <li onClick={closeSidebar}>  <HashLink smooth to="/#price" className="menu">Cost &amp; Plans</HashLink>

                    </li>
                    <li >
                        <Link to="/process-overview" onClick={() => window.scrollTo(0, 0)}> Process Overview</Link>


                    </li>


                    <li >
                        <Link to="/education" onClick={() => window.scrollTo(0, 0)}> Education</Link>
                    </li>

                    <li >
                        <Link to="/doc" onClick={() => window.scrollTo(0, 0)}> Doc</Link>
                    </li>

                    <HashLink smooth to="/#mission" className="menu">Our Mission</HashLink>

                    <li onClick={closeSidebar} ><a href="https://sandbox.algocontroller.com" className="menu accent-link">Login / Signup</a></li>




                </ul>
            </nav>

        </div>
    )
}

export default Header